/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, EventEmitter } from '@angular/core'


@Component({
  selector: 'bh-social',
  templateUrl: './social.template.html'
})

export class socialComponent implements OnInit {

  currentIndex; // Index of the currently selected tab

  ngOnInit() { }

  /**
   * When the focus of the tab group changes
   * store the index of the current selected
   * tab to currentIndex
   * @param event mdTabChange event
   */
  focusChanged(event) {
    this.currentIndex = event.index;
  }
}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/socialComponent/social.component.ts